module.exports = __webpack_public_path__ + "static/media/ReportSchoolRg-Regular.c8f29b69.otf";